import React, { Component } from 'react';
import { BrowserRouter as Router, NavLink, Link, Switch, Route } from 'react-router-dom'
import { withRouter } from 'react-router-dom';
import { OpenFormButton } from '../ContactForm'
import Headroom from "react-headroom";
import styled from 'styled-components';

import Menu from '../Menu';

class Header extends Component {
	state = {
		menuOpened: false,
	}

	toggleMenu = (force) => {
		this.setState({
			menuOpened: force !== undefined ? force : !this.state.menuOpened,
		})
		
	}

	render() {
		const { menuOpened } = this.state
		let path = this.props.location.pathname.replace('/', '')
		
		document.body.classList.toggle('menu-opened', this.state.menuOpened);

		return (
			<React.Fragment>
				<header className={`${path === '' ? '' : 'small'} ${path.indexOf('clients/') === 0 ? 'only-nav' : ''}`}>
					<Headroom disableInlineStyles>
						<nav id="navbar">

							<div className="logo">
								<h1><NavLink to="/"><img src="/images/blueshyft-logo.svg" /></NavLink></h1>
							</div>
					
							<div className="pages">
								<NavLink activeClassName="current-page" to="/about">ABOUT US</NavLink>
								<NavLink activeClassName="current-page" to="/clients">OUR CLIENTS</NavLink>
								<a href="https://locations.blueshyft.com.au" target="_blank">BROWSE NETWORK</a>
							</div>
					
							<div className="lets-talk-small">
								<OpenFormButton>LET'S TALK</OpenFormButton>
							</div>

							<div className={`menu-button ${menuOpened ? 'open' : ''}`}>
								<span className="menu-circle"></span>
								<span className="menu-link" onClick={() => this.toggleMenu()}>
									<span className="menu-icon"></span>
									<span className={`menu-line menu-line-1 ${menuOpened ? 'open' : ''}`}></span>
									<span className={`menu-line menu-line-2 ${menuOpened ? 'open' : ''}`}></span>
									<span className={`menu-line menu-line-3 ${menuOpened ? 'open' : ''}`}></span>
								</span>
							</div>
						</nav>
					</Headroom>
					<Switch>
						<Route exact path="/">
							<div className="container">
					
								<h2 className="appear">Accept in-store payments for your digital services</h2>
								<p className="appear">blueshyft’s retailer network of 1,500+ sites are equipped with an iOS based 
								platform allowing customers to make payments for digital goods and services.</p>
								
								<div className="lets-talk-big appear">
									<OpenFormButton>LET'S TALK</OpenFormButton>
								</div>

							</div>
						</Route>

						<Route path="/about">
							<div className="container">
								<h2>A unique solution backed by a dedicated team</h2>
							</div>
						</Route>

						<Route exact path="/clients">
							<div className="container">
								<h2>You're in good company</h2>
							</div>
						</Route>

						<Route path="/clients/">
							
						</Route>

						<Route exact path="/terms">
							<div className="container">
								<h2>Terms & Conditions</h2>
							</div>
						</Route>
						<Route exact path="/privacy-policy">
							<div className="container">
								<h2>Privacy Policy</h2>
							</div>
						</Route>

						<Route path="/blog-2020endofyearwrapup">
							<div className="container">
								<h2>2020 End of Year Wrap-Up</h2>
							</div>
						</Route>

						<Route path="/blogs/cryptocurrency">
							<div className="container">
								<h2>Cryptocurrency: a new type of digital dominance</h2>
							</div>
						</Route>

						<Route path="/blogs/footysback">
							<div className="container">
								<h2>Footy’s back</h2>
							</div>
						</Route>

						<Route path="/blogs/magicmay">
							<div className="container">
								<h2>Magic May: an important month for NRL and AFL</h2>
							</div>
						</Route>

						<Route path="/blogs/stateoforigin2021">
							<div className="container">
								<h2>State of Origin 2021: who will bring it home?</h2>
							</div>
						</Route>

						<Route path="/blogs/csr">
							<div className="container">
								<h2>A closer look at CSR</h2>
							</div>
						</Route>

						<Route path="/">
							<div className="container">
								<h2>404 not found</h2>
							</div>
						</Route>


					</Switch>
				</header>

				<Menu opened={menuOpened} closeMenu={() => this.toggleMenu(false) }/>
			</React.Fragment>
		)
		
	} 
}

let HeaderComponent = withRouter(props => <Header {...props}/>);
export default HeaderComponent



// WEBPACK FOOTER //
// ./client/components/Header/index.js